/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Elevation_RangeInputs */

const en_exp_elevation_range = /** @type {(inputs: Exp_Elevation_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flat: under 100m gain. Rolling: 100–300m. Hilly: 300–700m. Mountainous: 700m+. All relative to session distance.`)
};

const de_exp_elevation_range = /** @type {(inputs: Exp_Elevation_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flach: unter 100m. Wellig: 100–300m. Hügelig: 300–700m. Bergig: 700m+. Immer relativ zur Distanz sehen.`)
};

/**
* | output |
* | --- |
* | "Flat: under 100m gain. Rolling: 100–300m. Hilly: 300–700m. Mountainous: 700m+. All relative to session distance." |
*
* @param {Exp_Elevation_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_elevation_range = /** @type {((inputs?: Exp_Elevation_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Elevation_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_elevation_range(inputs)
	return de_exp_elevation_range(inputs)
});